import { SettingsPermissions } from "@redotech/account-common/permissions";
import { directMerchantAccess } from "../../settings-catalog/access";
import type {
  SettingGroupDefinition,
  SettingOwner,
  SettingRisk,
} from "../../settings-catalog/types";

export type CustomerPortalFlowEditorsFlatTeamSettingGroupId =
  "customer_portal_flow_editors.overview";

const customerportalfloweditorsOwner: SettingOwner = {
  kind: "teamSettings",
  product: "returns",
};

const customerportalfloweditorsRisk: SettingRisk = {
  level: "medium",
  reason: "Customer portal flow editing is customer-facing.",
};

export const CustomerPortalFlowEditorsFlatTeamSettingGroups = [
  {
    id: "customer_portal_flow_editors.overview",
    title: "Portal flow editor",
    description:
      "Editor for customer portal flows (returns, claims, warranties, withdrawals).",
    productArea: "returns",
    access: directMerchantAccess(
      SettingsPermissions.SET_RETURNS_AND_CLAIMS_SETTINGS,
    ),
    owner: customerportalfloweditorsOwner,
    risk: customerportalfloweditorsRisk,
    agentEditability: { mode: "requiresApproval" },
    fullPageTarget: { type: "settings", path: "customer-portal/flows/returns" },
    synonyms: ["portal flow editor", "flow editor", "return flow editor"],
  },
] as const satisfies readonly SettingGroupDefinition<CustomerPortalFlowEditorsFlatTeamSettingGroupId>[];
